import { render, staticRenderFns } from "./PayangelRewards.vue?vue&type=template&id=1a5e13df&"
import script from "./PayangelRewards.vue?vue&type=script&lang=js&"
export * from "./PayangelRewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports